// features/LayerSwitcher/components/LayerSLDWindow/index.jsx
import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import LayerSLDModal from './components/LayerSLDModal';
import './LayerSLDWindow.css';
import { Button } from 'primereact/button';

export default function LayerSLDWindow({ map, layer, wmsName , activeVisible}) {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);
  const btnRef = useRef(null);
  
  return (
    <div className="LayerSLDWindow">
      <Button
        className="HorizontalButton"
        alt={t('sld.tooltip') || 'Editar estilo (SLD)'}
        title={t('sld.tooltip') || 'Editar estilo (SLD)'}
        onClick={() => setActive(true)}
        ref={btnRef}
        icon="pi pi-palette"
      >
     
      </Button>

      <LayerSLDModal
        map={map}
        layer={layer}
        wmsName={wmsName}
        active={active}
        callback={setActive}
        
      />
    </div>
  );
}
